import images from "../../ImageVariables";
import { MFApropsTypes } from "../MFApropsTypes";
import "../SCSS/mobileStyles.css";
export default function MobileMFA({
  emailId,
  otp,
  handelOtpChange,
  activeOTPIndex,
  inputRef,
  handleOnkeyDown,
  handleVerifyOTP,
  handleResendOTP,
  otpError,
  handleOtpPaste,
}: MFApropsTypes) {
  const classNameOtpError = () => {
    if (otpError) {
      return "error";
    } else {
      return "no-error";
    }
  };
  return (
    <div className="mobile-mfa-main-container">
      <div className="mobile-mfa-container">
        <div className="mobile-mfa-image">
          <img
            className="mobile-otp-img"
            src={images.MobileOtpScreen}
            alt="otp"
          />
        </div>
        <div className="mobile-otp-image-inner-container">
          <div className="mobile-mfa-header-container">
            <div className="mobile-mfa-heading">ESG CF ASSESSMENT</div>
            <div className="mobile-mfa-header">ENTER VERIFICATION CODE</div>
            <div className="mobile-mfa-description">
              We have just sent a verification code to
              <span className="mobile-email-id">{emailId}</span>
            </div>
            <div className="mobile-enter-input-field-cover">
              {otp.map((_, index) => {
                return (
                  <div className="mobile-input-field" key={index}>
                    <input
                      className={
                        otp[index] || otpError
                          ? `mobile-input-number ${classNameOtpError()}`
                          : "mobile-input-no-number"
                      }
                      ref={index === activeOTPIndex ? inputRef : null}
                      type="number"
                      onChange={(event) => handelOtpChange(event)}
                      onKeyDown={(event) => handleOnkeyDown(event, index)}
                      onPaste={handleOtpPaste}
                      value={otp[index]}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="mobile-otp-error-main-container">
            <div
              className={`mobile-otp-error-inner-container ${
                otpError
                  ? "mobile-otp-error-inner-container"
                  : "mobile-otp-error-message"
              }`}
            >
              {otpError && <span className="mobile-otp-error">{otpError}</span>}
              {/* <div className="mobile-mfa-timer">Time remaining 02:00</div> */}
              <div className="mobile-mfa-resend-otp-cover">
                Didn't receive code?
                <span
                  className="mobile-resend-btn"
                  onClick={() => handleResendOTP()}
                >
                  Resend OTP
                </span>
              </div>
            </div>
            <div className="mobile-verify-button-cover">
              <input
                className="mobile-verify-button"
                type="button"
                value="VERIFY & PROCEED"
                onClick={() => handleVerifyOTP()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
